import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {pageSize} from '/constant/data.constant';
import {
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
} from '/enum/apiFields.enum';
import {getCoachWatchlist, getViewTeams} from '/redux/action/myTeams.action';
import {
  AllCandidatesReduxKeys,
  AllReferralReduxKeys,
  fetch,
  myTeams,
  MyteamsReduxKeys,
  resetReferralReport,
  resetReport,
} from '/redux/action/report.action';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  hasTeamsByCoachId,
  isViewTeamState,
  selectedTab,
  viewTeamsByCoachId,
  viewTeamsLoadingState,
} from '/redux/selector/myTeams.selector';
import {
  hasReportData,
  reportData,
  reportIsLoadingStateValue,
  reportMeta,
} from '/redux/selector/report.selector';
import {
  downlineCoachIds,
  watchlistCount,
} from '/redux/selector/watchList.selector';
import {calculatePageNumber} from '/util/requestParams.util';
import {withProps} from '/util/selector.util';

import PeopleReportDataRenderer from './PeopleReportDataRenderer';

//let initialLoadDone = false;

export default connect(
  createStructuredSelector({
    reportIsLoading: reportIsLoadingStateValue,
    hasReportData,
    reportData,
    reportMeta,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    coachHighestRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
    downlineCoachIds,
    count: watchlistCount,
    viewTeamsData: viewTeamsByCoachId,
    hasTeamsByCoach: hasTeamsByCoachId,
    viewTeamsLoadingState: viewTeamsLoadingState,
    tabsValue: selectedTab,
    isViewTeam: isViewTeamState,
  }),
  dispatch => ({
    fetchReport: ({reportName, reportParams, appendData}: any) =>
      dispatch(fetch({reportName, reportParams, appendData})),
    watchlist: () => dispatch(getCoachWatchlist()),
    fetchMyTeams: (params: any) => dispatch(myTeams(params)),
    fetchViewTeams: (params: any) => dispatch(getViewTeams(params)),
    resetReport: ({reportKey}: any) =>
      dispatch<any>(resetReport({reportKey, data: null})),
    resetReferralReport: ({referralReportKey}: any) =>
      dispatch<any>(resetReferralReport({referralReportKey, data: null})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {filtersData, reportName, coachId, ffTeamsOrgSR} = ownProps;
    const {tabsValue, isViewTeam} = stateProps;
    const fixViewTeamsPayload = (teamParams: any) => {
      const firstParam = teamParams?.reportParams?.[0] ?? {};

      return {
        coachId: teamParams.coachId,
        pageNumber: firstParam?.[PAGE_NUMBER_FIELD_NAME] ?? 1,
        appendData: false,
        isDrilldown: teamParams.isDrilldown,

        reportParams: [
          {
            ...firstParam,
            // bring all filters INSIDE reportParams
            sortBy: teamParams.sortBy,
            sortOrder: teamParams.sortOrder,
            period: teamParams.period,
            fibc: teamParams.fibc,
            frontline: teamParams.frontline,
            cabEarned: teamParams.cabEarned,
            aabEarned: teamParams.aabEarned,
            closeToNextRank: teamParams.closeToNextRank,
            rank: teamParams.rank,

            fqvMin: teamParams.fqvMin,
            fqvMax: teamParams.fqvMax,
            newClientsAbove: teamParams.newClientsAbove,
            newClientsBelow: teamParams.newClientsBelow,
            qualifiedClientsAbove: teamParams.qualifiedClientsAbove,
            qualifiedClientsBelow: teamParams.qualifiedClientsBelow,
            newCoachesAbove: teamParams.newCoachesAbove,
            newCoachesBelow: teamParams.newCoachesBelow,

            ...(teamParams.month ? {month: teamParams.month} : {}),
            ...(teamParams.days ? {days: teamParams.days} : {}),
          },
        ],
      };
    };

    const buildTeamParams = ({
      params,
      appendData,
    }: {
      params: any;
      appendData: boolean;
    }) => {
      const firstParam =
        Array.isArray(params) && params.length > 0 ? params[0] : {};

      // Remove isViewTeamsSortParams when watchlist + isViewTeam
      if (isViewTeam && tabsValue === 'watchlist') {
        delete firstParam.isViewTeamsSortParams;
      }

      const teamParams: any = {
        reportName:
          isViewTeam && tabsValue !== 'watchlist' ? 'VIEW_TEAMS' : reportName,
        reportParams: params,
        appendData,
        sortBy: params?.sortBy,
        sortOrder: params?.sortOrder,
        period: filtersData?.period,
        fibc: filtersData?.fibc,
        frontline: filtersData?.frontline,
        cabEarned: filtersData?.cabEarned,
        aabEarned: filtersData?.aabEarned,
        closeToNextRank: filtersData?.closeToNextRank,
        tabsValue,
        isViewTeam,
        ...(isViewTeam ? {coachId, ...params?.firstParam} : {}),
        ...(isViewTeam && firstParam?.isViewTeamsSortParams
          ? {
              sortBy: firstParam.sortBy,
              sortOrder: firstParam.sortOrder,
            }
          : {}),
      };
      if (filtersData?.period) {
        const {type, value} = filtersData.period;

        if (type === 'month') {
          teamParams.month = value;
        }

        if (type === 'days') {
          teamParams.days = value;
        }
      }

      if (
        Array.isArray(filtersData?.rank)
          ? filtersData?.rank.length > 0
          : filtersData?.rank && filtersData?.rank !== '[]'
      ) {
        teamParams.rank = filtersData?.rank;
      }

      // Add FQV and range filters
      if (filtersData?.fqvMin !== undefined) {
        teamParams.fqvMin = filtersData.fqvMin;
      }
      if (filtersData?.fqvMax !== undefined) {
        teamParams.fqvMax = filtersData.fqvMax;
      }
      if (filtersData?.newClientsAbove !== undefined) {
        teamParams.newClientsAbove = filtersData.newClientsAbove;
      }
      if (filtersData?.newClientsBelow !== undefined) {
        teamParams.newClientsBelow = filtersData.newClientsBelow;
      }
      if (filtersData?.qualifiedClientsAbove !== undefined) {
        teamParams.qualifiedClientsAbove = filtersData.qualifiedClientsAbove;
      }
      if (filtersData?.qualifiedClientsBelow !== undefined) {
        teamParams.qualifiedClientsBelow = filtersData.qualifiedClientsBelow;
      }
      if (filtersData?.newCoachesAbove !== undefined) {
        teamParams.newCoachesAbove = filtersData.newCoachesAbove;
      }
      if (filtersData?.newCoachesBelow !== undefined) {
        teamParams.newCoachesBelow = filtersData.newCoachesBelow;
      }

      return {teamParams, isViewTeam, reportName};
    };

    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,

      // Initial load
      fetchReport: () => {
        // if (initialLoadDone) return;
        const {reportIsLoading, isPeopleToContact} = stateProps;
        const shouldFetchWatchlist =
          tabsValue === 'watchlist' || reportName === 'MY_TEAMS';

        if (!reportIsLoading && !isPeopleToContact) {
          // initialLoadDone = true;

          if (shouldFetchWatchlist) {
            dispatchProps.watchlist();
          }
          const {reportParams: [firstParam = {}, ...restParams] = []} =
            ownProps;
          // Only add pagination if there are filters or non-default sorting
          const hasFilters = Object.keys(firstParam).length > 0;
          const params = hasFilters
            ? [
                {
                  ...firstParam,
                  [PAGE_SIZE_FIELD_NAME]: pageSize,
                  [PAGE_NUMBER_FIELD_NAME]: 1,
                },
                ...restParams,
              ]
            : [firstParam, ...restParams];
          const {teamParams, isViewTeam, reportName} = buildTeamParams({
            params,
            appendData: false,
          });
          if (
            (isViewTeam && tabsValue === 'watchlist') ||
            tabsValue === 'watchlist'
          ) {
            return dispatchProps.fetchMyTeams(teamParams);
          } else if (isViewTeam) {
            return dispatchProps.fetchViewTeams(
              fixViewTeamsPayload(teamParams),
            );
          }

          if (reportName === 'MY_TEAMS' && !isViewTeam) {
            return dispatchProps.fetchMyTeams(teamParams);
          }
          return dispatchProps.fetchReport({
            reportName,
            reportParams: params,
            appendData: false,
          });
        }
      },

      // Refresh after filter/tab change
      fetchUpdatedReport: () => {
        const {isPeopleToContact} = stateProps;
        if (isPeopleToContact) return;

        const {reportParams: [firstParam = {}, ...restParams] = []} = ownProps;
        // Only add pagination if there are filters or non-default sorting
        const hasFilters = Object.keys(firstParam).length > 0;
        const params = hasFilters
          ? [
              {
                ...firstParam,
                [PAGE_SIZE_FIELD_NAME]: pageSize,
                [PAGE_NUMBER_FIELD_NAME]: 1,
              },
              ...restParams,
            ]
          : [firstParam, ...restParams];
        const {teamParams, isViewTeam, reportName} = buildTeamParams({
          params,
          appendData: false,
        });
        if (tabsValue === 'watchlist') {
          return dispatchProps.fetchMyTeams(teamParams);
        }
        if (isViewTeam) {
          return dispatchProps.fetchViewTeams(fixViewTeamsPayload(teamParams));
        }
        if (reportName === 'MY_TEAMS' && !isViewTeam)
          return dispatchProps.fetchMyTeams(teamParams);

        return dispatchProps.fetchReport({
          reportName,
          reportParams: params,
          appendData: false,
        });
      },

      fetchMoreReport: () => {
        const {reportIsLoading, reportMeta, reportData, viewTeamsData} =
          stateProps;
        const {
          reportName,
          reportParams: [firstParam = {}, ...restParams] = [],
        } = ownProps;
        if (reportIsLoading) return;
        const {
          isEndReached,
          currentPage = 1,
          rankFilter,
          periodFilter,
          fibcFilter,
          frontlineFilter,
          cabEarned,
          aabEarned,
          nextRankFilter,
          fqvMin,
          fqvMax,
          newClientsAbove,
          newClientsBelow,
          qualifiedClientsAbove,
          qualifiedClientsBelow,
          newCoachesAbove,
          newCoachesBelow,
        } = reportMeta || {};
        if (isEndReached) return;

        const numberOfRecords = isViewTeam
          ? viewTeamsData?.length ?? 0
          : reportData?.length ?? 0;

        const total =
          reportMeta?.page?.filtercount ?? reportMeta?.page?.total ?? 0;

        const nextPageNumber = calculatePageNumber({
          numberOfRecords,
          pageSize,
          total,
        });
        if (!nextPageNumber) return;
        if (nextPageNumber <= currentPage) return;

        const params = [
          {
            ...firstParam,
            [PAGE_SIZE_FIELD_NAME]: pageSize,
            [PAGE_NUMBER_FIELD_NAME]: nextPageNumber,
          },
          ...restParams,
        ];

        const {teamParams, reportName: rn} = buildTeamParams({
          params,
          appendData: true,
        });
        // Apply filters
        if (rankFilter) teamParams.rank = rankFilter;
        if (periodFilter) {
          if (ffTeamsOrgSR) {
            teamParams.month = periodFilter;
          } else {
            teamParams.days = periodFilter;
          }
        }
        if (fibcFilter) teamParams.fibc = fibcFilter;
        if (frontlineFilter) teamParams.frontline = frontlineFilter;
        if (cabEarned) teamParams.cabEarned = cabEarned;
        if (aabEarned) teamParams.aabEarned = aabEarned;
        if (nextRankFilter) teamParams.closeToNextRank = nextRankFilter;
        if (fqvMin !== undefined) teamParams.fqvMin = fqvMin;
        if (fqvMax !== undefined) teamParams.fqvMax = fqvMax;
        if (newClientsAbove !== undefined)
          teamParams.newClientsAbove = newClientsAbove;
        if (newClientsBelow !== undefined)
          teamParams.newClientsBelow = newClientsBelow;
        if (qualifiedClientsAbove !== undefined)
          teamParams.qualifiedClientsAbove = qualifiedClientsAbove;
        if (qualifiedClientsBelow !== undefined)
          teamParams.qualifiedClientsBelow = qualifiedClientsBelow;
        if (newCoachesAbove !== undefined)
          teamParams.newCoachesAbove = newCoachesAbove;
        if (newCoachesBelow !== undefined)
          teamParams.newCoachesBelow = newCoachesBelow;

        // if (isViewTeamState) {
        //   return dispatchProps.fetchViewTeams(teamParams);
        // } else
        // if (rn === 'MY_TEAMS' && !isViewTeam) {
        if (tabsValue === 'watchlist' || (rn === 'MY_TEAMS' && !isViewTeam)) {
          return dispatchProps.fetchMyTeams(teamParams);
        } else {
          return dispatchProps.fetchReport({
            reportName,
            reportParams: params,
            appendData: true,
          });
        }
      },
      // Resetters
      resetCandidatesData: () => {
        AllCandidatesReduxKeys.forEach(element =>
          dispatchProps.resetReport({reportKey: element}),
        );
      },
      resetMyTeamsData: () => {
        MyteamsReduxKeys.forEach(element =>
          dispatchProps.resetReport({reportKey: element}),
        );
      },
      resetAllReferralData: () => {
        AllReferralReduxKeys.forEach((element: any) =>
          dispatchProps.resetReferralReport({reportKey: element}),
        );
      },
    };
  },
)(PeopleReportDataRenderer);
